import React from "react";
import { Switch, Route } from "react-router-dom";
// import KeepAlive from "react-activation";
import Bill from "@/pages/sanyi/bill/bill";
import PayBill from "@/pages/sanyi/pay-bill/pay-bill";
import DormList from "@/pages/sanyi/dorm-list/dorm-list";
import DormManage from "@/pages/sanyi/dorm-manage/dorm-manage";
import Checkout from "@/pages/sanyi/checkout/checkout";
import Relet from "@/pages/sanyi/relet/relet";
import ChangeBed from "@/pages/sanyi/change-bed/change-bed";
import BookingDetail from "@/pages/sanyi/booking-detail/booking-detail";
import Sign from "@/pages/sanyi/sign/sign";
import SYUserSign from "@/pages/sanyi/user-sign/user-sign";
import LineupDetail from "@/pages/sanyi/lineup/lineup";
// 预约房间
import BookRoom from "@/pages/sanyi/book-room/book-room";
import BookInfo from "@/pages/sanyi/book-room/book-info/book-info";
import LineupInfo from "@/pages/sanyi/book-room/lineup-info/lineup-info";
// 充值页面
import Recharge from "@/pages/sanyi/recharge/recharge";
import RechargeHistory from "@/pages/sanyi/recharge-history/recharge-history";
// 选择门店
import ChangeStore from "@/pages/sanyi/change-store/change-store";
import ChangeArea from "@/pages/sanyi/change-area/change-area";
import ChangePark from '@/pages/sanyi/change-park/change-park'

import Login from "@/pages/sanyi/login/login";

function SanyRoute({ match }: any) {
  return (
    <Switch>
      <Route exact path={`${match.path}/login`} component={Login} />
      <Route exact path={`${match.path}/change-park`} component={ChangePark} />
      <Route exact path={`${match.path}/change-area`} component={ChangeArea} />
      <Route exact path={`${match.path}/change-store`} component={ChangeStore} />
      <Route exact path={`${match.path}/book-info`} component={BookInfo} />
      <Route exact path={`${match.path}/lineup-info`} component={LineupInfo} />
      <Route exact path={`${match.path}/lineup-detail`} component={LineupDetail} />
      <Route exact path={`${match.path}/book-room`} component={BookRoom} />
      <Route exact path={`${match.path}/bill`} component={Bill} />
      <Route exact path={`${match.path}/pay-bill`} component={PayBill} />
      <Route exact path={`${match.path}/dorm-list`} component={DormList}></Route>
      <Route exact path={`${match.path}/dorm-manage`} component={DormManage} />
      <Route exact path={`${match.path}/checkout`} component={Checkout} />
      <Route exact path={`${match.path}/relet`} component={Relet} />
      <Route exact path={`${match.path}/change-bed`} component={ChangeBed} />
      {/* 充值和充值历史 */}
      <Route exact path={`${match.path}/recharge`} component={Recharge} />
      <Route exact path={`${match.path}/recharge-history`} component={RechargeHistory} />
      {/* <Route exact path={`${match.path}/change-bed`}>
        <KeepAlive><ChangeBed/></KeepAlive>
      </Route> */}
      <Route exact path={`${match.path}/booking-detail`} component={BookingDetail} />
      <Route exact path={`${match.path}/sign`} component={Sign} />
      <Route exact path={`${match.path}/user-sign`} component={SYUserSign} />
    </Switch>
  )
}

export default SanyRoute